import { Component, OnInit, EventEmitter, Input, Output, ChangeDetectorRef, ComponentRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, FormControl, ReactiveFormsModule } from '@angular/forms';
import { TgSettingsService } from '../../../../services/TG-Setting_Services/tg-settings.service';
import { PowerSearchApiService } from '../../Services/power-search-service.service';
import { Question } from '../../Models/power-search-view-response.model';
import { SmartSearchRequest } from '../../Models/smart-search-request.model';
import { StyledInputDirective } from '../../../Common/Directives/styled-input.directive';
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { Title } from '@angular/platform-browser';
import { PrimengAutoCompleteComponent } from '../../../Common/Components/primeng-auto-complete/primeng-auto-complete.component';
import { PrimengDateInputComponent } from '../../../Common/Components/primeng-date-input/primeng-date-input.component';
import { PrimengAutocompleteSingleSelectComponent } from '../../../Common/Components/primeng-autocomplete-single-select/primeng-autocomplete-single-select.component';
import { LegacyDateInputComponent } from 'app/Modules/Common/Components/legacy-date-input/legacy-date-input.component';
import { DecodeHtmlPipe } from 'app/Modules/Common/pipes/decode-html.pipe';
import { SafeHtmlPipe } from 'app/Modules/Common/pipes/safe-html.pipe';
import { TranslationInitService } from 'app/services/Translate_Services/translation-init.service';
@Component({
  selector: 'app-powersearch',
  standalone: true,
  templateUrl: './power-search.component.html',
  styleUrls: ['./power-search.component.scss'],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule, 
    StyledInputDirective, 
    TranslateModule, 
    PrimengAutoCompleteComponent,
    PrimengDateInputComponent,
    PrimengAutocompleteSingleSelectComponent, DecodeHtmlPipe, SafeHtmlPipe
  ]
})
export class PowerSearchComponent implements OnInit {
  questions: Question[] = [];
  powerSearchErrorMsgs: any[] = [];
  powersearchSubmitted = false;
  keyWordSearch = { text: '', id: 'ps-keyword-input' };
  locationSearch = { text: '', id: 'ps-location-input' };
  tgSettings: any = {};
  dynamicStrings: any = {};
  sessionKey = '';
  postDateControl = new FormControl<Date | null>(null);
SearchButtonText = '';
hidekeyword=false;
hidelocation=false;
  @Input() model!: any;
  @Input() locale: string = 'en-GB';
  @Output() modelChange = new EventEmitter<any>();
  singleDateCtrl = new FormControl<any>(null);
  rangeDateCtrl = new FormControl<any>(null);
  monthDateCtrl = new FormControl<any>(null);
  TgSettings: any = {};
  powersearchvisible = false;
  currentComponentRef: ComponentRef<any> | null = null;

  constructor(private api: PowerSearchApiService,private titleService: Title, private cdr: ChangeDetectorRef, private translate: TranslateService, private tgSettingsService: TgSettingsService,private translationInit: TranslationInitService) {
    this.tgSettingsService.settings$.subscribe(settings => {
      this.TgSettings = settings || {};
      this.cdr.markForCheck();
    });
  }

  ngAfterViewInit() {
    this.translate.onLangChange.subscribe(() => {
      this.cdr.detectChanges();
    });
  }

  onComparisonDateChange(formattedString: string) {
  }

  ngOnInit(): void {
    const partnerId = this.getHiddenFieldValue('partnerId');
    const siteId = this.getHiddenFieldValue('siteId');
    this.locale = this.tgSettingsService.getLocale() || 'en-GB';
    this.sessionKey = `powersearch_${partnerId}_${siteId}`;
    
    this.loadQuestions();
    document.title = this.translationInit.getInstantTranslation('Title_PowerSearch');
  }

  private getHiddenFieldValue(id: string): number {
    return Number((document.getElementById(id) as HTMLInputElement)?.value) || 0;
  }

  cancel() {
   
    window.history.back();
    
    
  }

  loadQuestions(CancelRequest?: boolean) {
    const partnerId = this.getHiddenFieldValue('partnerId');
    const siteId = this.getHiddenFieldValue('siteId');
    const appScope = (window as any).appScope;
    this.SearchButtonText = appScope.tgSettings.SearchActionButtonText;
    this.hidekeyword= appScope.tgSettings.HideKeywordSearchBox === 'yes';
    this.hidelocation= appScope.tgSettings.HideLocationSearchBox === 'yes';

    this.api.getPowerSearchQuestions(partnerId, siteId).subscribe({
      next: (res) => {
        this.questions = res?.Questions || [];
        this.powersearchvisible = true;
          // 🔥 FIX: Initialize the FormControl dynamically, bypassing TS errors
        this.questions.forEach(q => {
          if (q.QuestionType === 'date') {
             (q as any).dateCtrl = new FormControl(null);
          }
        });
        if (appScope) {
          appScope.bpowersearchvisible = true;
          appScope.workFlow = "powerSearch";
          appScope.bInitialLoad = false;
            
          this.keyWordSearch.text = appScope.keyWordSearch?.text || '';
          this.locationSearch.text = appScope.locationSearch?.text || '';
        }
          
        this.restoreSession();
      },
      error: (err) => {
        console.error("POWER SEARCH ERROR", err);
        this.powersearchvisible = false; 
        if (appScope) {
          appScope.bpowersearchvisible = false;
          appScope.workFlow = "welcome"; 
        }
      }
    });
  }

  onDateChange(q: any, formattedString: string) {
    q.Value = formattedString;
    this.saveSession(); 
  }

  clearCurrentComponent() {
    if (this.currentComponentRef) {
      this.currentComponentRef.destroy();
      this.currentComponentRef = null;
      document.getElementById('powerSearchContainer')!.innerHTML = ""; 
    }
  }

  GoBack() {
    this.clearCurrentComponent();
    window.history.back();
  }

  /** SESSION PERSISTENCE */
saveSession() {
    const appScope = (window as any).appScope;

    const transformedQuestions = this.questions.map(q => {
      
      // 🔥 DATE FIELDS: Just transform the Value and ignore everything else.
      if (q.QuestionType === 'date') {
        return { 
          ...q, 
          Value: this.convertDateToLegacy(q.Value) 
        };
      }

      // 🛠️ NON-DATE FIELDS: Transform selectedOptions (for dropdowns, checkboxes, etc.)
      return {
        ...q,
        selectedOptions: (q.selectedOptions || []).map((opt: any) => {
          const rawVal = opt.value || opt.OptionValue || opt.data || opt;
          const rawLabel = opt.label || opt.OptionName || opt.data || opt;
          return { value: rawVal, label: rawLabel, data: rawVal };
        })
      };
    });

    // Step 2: Assign to appScope for the legacy UI
    if (appScope) {
      if (appScope.keyWordSearch) appScope.keyWordSearch.text = this.keyWordSearch.text || "";
      if (appScope.locationSearch) appScope.locationSearch.text = this.locationSearch.text || "";
      appScope.powerSearchQuestions = transformedQuestions;
    }

    // Step 3: Save to session
    const dataToSave = {
      questions: transformedQuestions, 
      keyword: this.keyWordSearch.text,
      location: this.locationSearch.text
    };
    
    // localStorage.setItem(this.sessionKey, JSON.stringify(dataToSave));
  }

 restoreSession() {
    const appScope = (window as any).appScope;
    
    if (!appScope) return; // If there is no appScope (e.g., F5 refresh), we do nothing.

    // 1. Restore Keyword & Location directly from appScope
    this.keyWordSearch.text = appScope.keyWordSearch?.text || '';
    this.locationSearch.text = appScope.locationSearch?.text || '';

    // 2. Restore Questions directly from appScope.powerSearchQuestions
    const savedQuestions = appScope.powerSearchQuestions;
    if (!savedQuestions || !Array.isArray(savedQuestions)) return;

    this.questions.forEach(q => {
      const prev = savedQuestions.find((p: any) => p.QId === q.QId);
      
      if (prev) {
        // 🔥 THE REVERSE MAPPING 🔥
        // Give PrimeNG back the exact objects so the UI chips render perfectly
        q.selectedOptions = prev.selectedOptions || [];

        // Extract raw strings so the API payload is ready
        q.SelectedOptions = (prev.selectedOptions || []).map((opt: any) => 
           opt.data || opt.value || opt.OptionValue || opt
        );

        // Restore normal text values
        q.Value = prev.Value;

        // Restore Date UI controls
       if (q.QuestionType === 'date') {
          if (!(q as any).dateCtrl) {
            (q as any).dateCtrl = new FormControl(null);
          }

          if (q.Value) {
            const decodedValue = decodeURIComponent(q.Value);
            if (q.QId != -1) { 
              const parts = decodedValue.split(','); 
              if (parts.length === 2) {
                  const d1 = this.parseCustomDate(parts[0]);
                  const d2 = this.parseCustomDate(parts[1]);
                  if (d1 && !isNaN(d1.getTime()) && d2 && !isNaN(d2.getTime())) {
                      (q as any).dateCtrl.setValue([d1, d2], { emitEvent: false }); 
                  } else {
                      (q as any).dateCtrl.setValue(null, { emitEvent: false });
                  }
              } else {
                  (q as any).dateCtrl.setValue(null, { emitEvent: false });
              }
            } else { 
              const singleDate = this.parseCustomDate(decodedValue);
              if (singleDate && !isNaN(singleDate.getTime())) {
                 (q as any).dateCtrl.setValue(singleDate, { emitEvent: false });
              } else {
                 (q as any).dateCtrl.setValue(null, { emitEvent: false });
              }
            }
          }
        }
        // Restore Checkbox "Selected" boolean states
        if (q.Options && prev.Options) {
          q.Options.forEach((opt: any, index: number) => {
            if (prev.Options[index]) {
              opt.Selected = prev.Options[index].Selected;
            }
          });
        }
      }
    });
  }

  onMultiSelectChange(q: any, selected: any[]) {
    q.selectedOptions = selected;
    q.SelectedOptions = selected.map(s => s.data || s.value || s.label || s);
    this.saveSession();
  }

  private parseCustomDate(inputDate: string): Date | null {
    if (!inputDate) return null;
    let dateFormatSetting = "1";
    if (this.tgSettingsService && typeof (this.tgSettingsService as any).getdateFormat === 'function') {
       dateFormatSetting = (this.tgSettingsService as any).getdateFormat().toString();
    }

    let separatedBy = "/";
    let mIdx = 0, dIdx = 1, yIdx = 2;

    if (["1", "6", "7", "8"].includes(dateFormatSetting)) { mIdx = 0; dIdx = 1; yIdx = 2; }
    else if (["2", "3", "4", "5"].includes(dateFormatSetting)) { mIdx = 1; dIdx = 0; yIdx = 2; }
    else if (["9", "10", "11", "12"].includes(dateFormatSetting)) { mIdx = 1; dIdx = 2; yIdx = 0; }

    if (["4", "7", "10", "12"].includes(dateFormatSetting)) separatedBy = "-";
    else if (["5", "8", "11"].includes(dateFormatSetting)) separatedBy = ".";
    else separatedBy = "/";

    try {
      const parts = inputDate.split(separatedBy);
      if (parts.length !== 3) return new Date(inputDate); 
      const mm = parts[mIdx];
      const dd = parts[dIdx];
      const yyyy = parts[yIdx];
      return new Date(`${mm}/${dd}/${yyyy}`);
    } catch (e) {
      return null;
    }
  }

 private buildPowerSearchOptions() {
    return this.questions.map(q => {
      const obj: any = {
        VerityZone: q.VerityZone,
        Type: q.QuestionType
      };

      const qType = (q.QuestionType || '').toLowerCase();

      // 1. Text / Numeric
      if (["text", "textarea", "email", "numeric"].includes(qType)) {
        obj.Value = q.Value || "";
      } 
      // 🔥 2. DATE: ONLY BINDING. No strings, no formatting!
      else if (qType === 'date') {
        const ctrl = (q as any).dateCtrl;
        // Direct ga form control lo unna array leda Date object ni ichestunnam
        obj.Value = ctrl && ctrl.value ? ctrl.value : ""; 
      } 
      // 3. Multi-Select / Checkbox
      else {
        let codes: any[] = [];
        if (q.SelectedOptions && q.SelectedOptions.length > 0) {
          codes = [...q.SelectedOptions];
        } else if (q.selectedOptions && q.selectedOptions.length > 0) {
          codes = q.selectedOptions.map((s: any) => s.data || s.value || s.label || s);
        }

        if (q.Options && q.Options.length > 0) {
          const checkboxCodes = q.Options.filter((o: any) => o.Selected === true).map((o: any) => o.OptionValue);
          checkboxCodes.forEach((c: any) => {
            if (!codes.includes(c)) codes.push(c);
          });
        }
        obj.OptionCodes = codes;
      }
      
      return obj;
    });
  }

private buildSmartSearchRequest(): SmartSearchRequest {
    const kw = this.keyWordSearch.text;
    
    // Step A: Get the raw bound data (Dates are still JS objects/arrays here)
    let rawOptions = this.buildPowerSearchOptions();

    // 🔥 Step B: TRANSFORM ONLY HERE (Right before API Call)
    const formattedOptions = rawOptions.map((obj: any) => {
      if (obj.Type === 'date' && obj.Value) {
        const val = obj.Value; // This holds our raw Date or Array of Dates
        
        if (Array.isArray(val) && val[0] && val[1]) {
            // Transform Range Date
            obj.Value = `${this.formatLegacyDateAPI(val[0])},${this.formatLegacyDateAPI(val[1])}`;
        } else if (Array.isArray(val) && val[0]) {
            // Transform Array with only 1 Date
            obj.Value = this.formatLegacyDateAPI(val[0]);
        } else if (val instanceof Date && !isNaN(val.getTime())) {
            // Transform Single Date
            obj.Value = this.formatLegacyDateAPI(val);
        } else {
            obj.Value = "";
        }
      }
      return obj;
    });

    // Step C: Send the transformed payload
    return {
      PartnerId: this.getHiddenFieldValue('partnerId'),
      SiteId: this.getHiddenFieldValue('siteId'),
      Keyword: [kw],
      ListKeyword: [kw],
      Location: [this.locationSearch.text],
      KeywordCustomSolrFields: this.TgSettings?.tgSettings?.KeywordCustomSolrFields ,
      LocationCustomSolrFields: this.TgSettings?.tgSettings?.LocationCustomSolrFields ,
      Latitude: 0,
      Longitude: 0,
      Radius: 0,
      FacetFilterFields: { Facet: [] },
      SortType: "",
      PageNumber: 1,
      CallType: "",
      SocialReferalType: "",
      PowerSearchOptions: {
        PowerSearchOption: formattedOptions // 🔥 Attach exactly here!
      },
      EncryptedSessionValue: "",
      localizedStrings: {},
      JobSiteIds: "",
      RunSavedSearch: false,
      TurnOffHttps: false,
      LinkID: 0,
      JobCountOnly: false,
      SearchResumeName: "",
      MatchedReqIds: [],
      ClearSession: false,
      UserGivenKeyWords: kw
    };
  }
  powerSearchJobs() {
    this.saveSession(); // Push exact data to session and appScope
    this.powersearchSubmitted = true;
    const req = this.buildSmartSearchRequest();
    const token = (document.querySelector("[name='__RequestVerificationToken']") as HTMLInputElement)?.value;
    const appScope = (window as any).appScope;

    // 🔥 FIX 3: Assign payload to legacy scope so tags render on the results page!
    if (appScope) {
      appScope.GeneralJobSubmissionWorkflow = false;
      appScope.bSearchSaved = false;
      appScope.smartSearchRequest = req; 
      
      if (typeof appScope.updateSaveSearchCritetia === 'function') {
        appScope.updateSaveSearchCritetia(req);
      }
    }

    // Force the legacy UI to redraw
    window.dispatchEvent(new CustomEvent('facetFilterChanged', { detail: req }));
    this.api.getPowerSearchJobs(req, token).subscribe({
      next: (response) => {
        if (appScope?.UpdateSearcResultsbyPowersearch) {
          const legacyArguments = [response, 200, () => null, {}];
          this.powersearchvisible = false;
          this.clearCurrentComponent(); 
          appScope.UpdateSearcResultsbyPowersearch(response, legacyArguments);
        } else {
          console.warn("Legacy method UpdateSearcResultsbyPowersearch not found");
        }
      },
      error: (err) => console.error("POWER SEARCH ERROR", err)
    });
  }

  private formatLegacyDateAPI(date: Date): string {
    if (!date || isNaN(date.getTime())) return '';
    return `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`;
  }
private convertDateToLegacy = (val: any): string => {
  if (!val) return "";
  
  // 1. If it's already an array or Date object
  if (Array.isArray(val)) return val.filter(v => v).map(v => this.formatLegacyDateAPI(v)).join(',');
  if (val instanceof Date) return this.formatLegacyDateAPI(val);

  // 🔥 2. THE FIX: If it's a string, we MUST parse it first, then add the '/'
  if (typeof val === 'string') {
    // Split by comma in case it's a range like "15-02-2024,20-02-2024"
    const parts = decodeURIComponent(val).split(','); 
    
    return parts
      .map(p => this.parseCustomDate(p)) // Convert UI string back to JS Date
      .filter(d => d && !isNaN(d.getTime())) // Ensure it's a valid date
      .map(d => this.formatLegacyDateAPI(d!)) // Format it to YYYY/M/D (Adds the '/' !)
      .join(',');
  }
  
  return "";
}
  
}
